<template>
	<div class="search-container">
		<input
			type="search"
			placeholder="Zoeken"
			v-model="searchInput"
			v-on:input="debounceCallback()"
		/>
		<button @click="sync" :class="{syncing: isSyncing}">
			<RefreshCwIcon size="1.25x"/>
		</button>
	</div>
</template>

<script>
import Button from "@/components/Button.vue";
import DateField from "@/components/DateField.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import ToggleField from "@/components/ToggleField.vue";
import axios from "axios";
import _ from "lodash";
import RefreshCwIcon from "vue-feather-icons/icons/RefreshCwIcon";
import {mapGetters, mapState} from "vuex";

export default {
	components: {
		RefreshCwIcon,
		LoadingIndicator,
		Button,
		DateField,
		ToggleField,
	},

	data() {
		return {
		debounceCallback: null,
		searchInput: "",
		isSyncing: false
		};
	},

	created() {
		this.debounceCallback = _.debounce(value => {
			this.$emit("search", this.searchInput);
		}, 200);
	},
	destroyed() {
		this.debounceCallback.cancel();
	},
	computed: {
		...mapState("map", {
			mapType: "mapType"
		})
	},

	methods: {
		sync() {
			this.isSyncing = true;
			let syncFunction = this.syncCompanies;
			if (this.mapType === "uitvoering" || this.mapType === "execution-appointments" || this.mapType === "support") {
				syncFunction = this.syncProjects;
			}

			syncFunction().then(() => {
				this.isSyncing = false;
				this.$emit("refresh", {});
				this.$notify({
					group: 'app',
					title: 'Map',
					type: 'success',
					text: `Synchroniseren is gelukt`
				});
			}).catch(error => {
				this.isSyncing = false;
				this.$notify({
					group: 'app',
					title: 'Map',
					type: 'error',
					text: `Synchroniseren is niet gelukt`
				});
				this.$emit("refresh", {});
			});
		},

		syncProjects() {
			return Promise.all([this.syncCompanies(), this.doSync("projects")]);
		},

		syncCompaniesLocation() {
			return this.doSync("companiesgeo");
		},

		syncCompanies() {
			return new Promise((resolve, reject) => {
				this.doSync("companies").then(() => {
					this.syncCompaniesLocation().then(() => {
						resolve();
					}).catch(error => {
						reject(error);
					});
				}).catch(error => {
					reject(error);
				});
			});
		},

		doSync(type) {
			return new Promise((resolve, reject) => {
				axios.get("/api/sync/" + type, {
					params: {
						apikey: "363f9d9f-214c-46e3-bcf3-aed95870340f",
						isFirstRun: false
					}
				}).then(json => {
					if (json.data.response.result.more_items_in_collection) {
						setTimeout(() => {
							this.doSync(type, false).then(() => {
								resolve();
							}).catch(error => {
								reject(error);
							});
						}, 1000);
					} else if (!json.data.response.error) {
						resolve();
					} else {
						console.log(json.data.response.error);
						reject(json.data.response.error);
					}
				}).catch(error => {
					console.log(error);
					reject(error);
				});
			});
		}
	}
};
</script>

<style scoped lang="scss">
.loading-container {
	color: #777777; font-size: 13px; position: absolute;

	.loading-indicator {
		height: 16px;
	}
}
</style>
